export const convertMiliseconds = ({
  miliseconds,
  showDays = true,
  showHours = true,
  showMInutes = true,
}) => {
  const days = showDays
    ? Math.floor(miliseconds / (1000 * 60 * 60 * 24)) + "d "
    : "";
  const seconds =
    Math.floor((miliseconds / 1000) % 60) < 10
      ? "0" + Math.floor((miliseconds / 1000) % 60)
      : Math.floor((miliseconds / 1000) % 60);
  const minutes =
    Math.floor((miliseconds / (1000 * 60)) % 60) < 10
      ? "0" + Math.floor((miliseconds / (1000 * 60)) % 60)
      : Math.floor((miliseconds / (1000 * 60)) % 60);
  const hours = showHours
    ? Math.floor((miliseconds / (1000 * 60 * 60)) % 24) < 10
      ? "0" + Math.floor((miliseconds / (1000 * 60 * 60)) % 24) + "h:"
      : Math.floor((miliseconds / (1000 * 60 * 60)) % 24) + "h:"
    : "";
  return `${days}${hours}${minutes}m:${seconds}s`;
};
